import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import "./Register.css";
import ForgotPasswordModal from "./ForgotPasswordModal";

const Register = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [specialCode, setSpecialCode] = useState("");
  const [showPremiumNotice, setShowPremiumNotice] = useState(false);
  const [showWarningBanner, setShowWarningBanner] = useState(false);
  const [registeredUserId, setRegisteredUserId] = useState(null);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [showForgotPasswordButton, setShowForgotPasswordButton] =
    useState(false);
  const location = useLocation();
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const promoCode = params.get("promo");
    if (promoCode) {
      setSpecialCode(promoCode);
    }
  }, [location.search]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/users/register`,
        {
          username,
          password,
          email,
          role: "FREE_USER",
          specialCode,
        },
        {
          withCredentials: true,
        }
      );

      if (response.data.id) {
        setLoading(false);
        setSuccess("Registration successful!");
        setRegisteredUserId(response.data.id);

        if (response.data.specialCode === "MAGGIE10") {
          // Trigger the popup
          setShowPremiumNotice(true);
        } else {
          // Normal behavior
          setTimeout(() => {
            if (typeof window.triggerLoginModal === "function") {
              window.triggerLoginModal({ email, password });
            }
          }, 2500);
        }
      } else {
        throw new Error("Registration failed");
      }
    } catch (error) {
      console.error(error);
      setLoading(false);

      if (error.response && error.response.data && error.response.data.error) {
        const errorMsg = error.response.data.error;
        setError(errorMsg);

        if (
          errorMsg.toLowerCase().includes("user") &&
          errorMsg.toLowerCase().includes("exist")
        ) {
          setShowForgotPasswordButton(true);
        }
      } else {
        setError("An unexpected error occurred. Please try again.");
      }
    }
  };

  const handleActivatePremium = async () => {
    if (!registeredUserId) {
      alert("User ID not available");
      return;
    }
    try {
      const res = await axios.post(
        `${baseUrl}/payments/create-special-checkout-session`,
        {
          priceId: process.env.REACT_APP_STRIPE_PREMIUM_PRICE_ID,
          userId: registeredUserId,
        },
        { headers: { "Content-Type": "application/json" } }
      );
      window.location.href = res.data.url;
    } catch (error) {
      console.error(error);
      alert("Error starting special Stripe session.");
    }
  };

  // const handleContinueWithoutPremium = () => {
  //   setShowSpecialCodeModal(false);
  //   setShowWarningBanner(true);

  //   // Trigger the login modal
  //   if (typeof window.triggerLoginModal === "function") {
  //     window.triggerLoginModal({ email, password });
  //   }
  // };

  return (
    <div className="register-component-container">
      {showPremiumNotice && (
        <div className="premium-notice-popup">
          <div className="popup-content">
            <h2>🎉 Premium Trial Activated!</h2>
            <p>
              You now have <strong>Premium access</strong> to BlockCode for 14
              days.
              <br />
              After that, you'll get{" "}
              <strong>50% off a 1-year subscription</strong> if you wish to
              continue.
            </p>
            <button
              className="login-button"
              onClick={() => {
                if (typeof window.triggerLoginModal === "function") {
                  window.triggerLoginModal({ email, password });
                }
                setShowPremiumNotice(false); // 👈 hide the modal
              }}
            >
              Log In to Start
            </button>
          </div>
        </div>
      )}

      {/* {showWarningBanner && (
        <div className="special-access-banner">
          ⚡️ You have special access to a free Premium trial for 14 days!
          Without accepting this, you will have limited access to many site
          features.
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              setShowSpecialCodeModal(true);
            }}
          >
            Click here to activate it.
          </a>
        </div>
      )} */}

      {error && <div className="error">{error}</div>}
      {showForgotPasswordButton && (
        <div className="forgot-password-button-container">
          <button
            className="forgot-password-button"
            onClick={() => setShowForgotPasswordModal(true)}
          >
            Forgot Password?
          </button>
        </div>
      )}

      {loading && <div className="loading">Loading...</div>}
      {success && <div className="success">{success}</div>}
      <div className="register-header">
        <h1>Create Account</h1>
      </div>
      <form className="register-form" onSubmit={handleSubmit}>
        <div className="register-form-email">
          <label>
            Email:
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
        </div>
        <div className="register-form-username">
          <label>
            Username:
            <input
              type="text"
              name="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </label>
        </div>
        <div className="register-form-password">
          <label>
            Password:
            <input
              type="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </label>
        </div>
        <div className="register-form-special-code">
          <label>
            Special Access Code (optional):
            <input
              type="text"
              name="specialCode"
              value={specialCode}
              onChange={(e) => setSpecialCode(e.target.value)}
              placeholder="Enter code if you have one"
            />
          </label>
        </div>
        {/* <div className="register-form-role">
          <label>
            Role:
            <select
              name="role"
              id="roleSelect"
              value={role}
              onChange={(e) => setRole(e.target.value)}
            >
              <option value="">--Please choose an option--</option>
              <option value="FREE_USER">Free User</option>
            </select>
          </label>
        </div> */}


       {/*} <div className="register-form-submit">
          <button type="submit" className="register-submit-button">
            Register
          </button>
        </div> */}


      </form>
      {showForgotPasswordModal && (
        <ForgotPasswordModal
          email={email}
          onClose={() => setShowForgotPasswordModal(false)}
        />
      )}
    </div>
  );
};

export default Register;
